import { useState, FC, useEffect } from 'react';
import { useFilters, BoxV2 as Box, Flex, TableFilter } from 'portal-commons';

import { FilterToggleButton } from '@/shared_elements';
import { enumController, profileController } from '@/apis/core';

interface FiltersProps {
  filter: ReturnType<typeof useFilters>;
}

const Filters: FC<FiltersProps> = ({ filter }) => {
  const { appliedFilters, candidateFilters } = filter;
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    const { setOptions } = filter;
    const usecaseTypes = await enumController.getUsecaseTypes({
      channelId: 'RCS',
    });
    setOptions(
      'usecase',
      usecaseTypes.map((item) => ({
        label: item.id,
        value: item.id,
      }))
    );
    const approvedDcas = await profileController.getApprovedDcas();
    setOptions(
      'dcaUid',
      approvedDcas.map((item) => ({
        label: item.displayName,
        value: item.uid,
      }))
    );
    const billingCategories = await enumController.getBillingCategories();
    setOptions(
      'billingCategory',
      billingCategories.map((item) => ({
        label: item,
        value: item,
      }))
    );
  };

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        marginTop: 's',
        marginBottom: isFilterVisible ? 's' : undefined,
      }}
    >
      <Box sx={{ mb: 's' }}>
        <FilterToggleButton
          visible={isFilterVisible}
          onClick={toggleFilterVisibility}
        />
      </Box>
      {isFilterVisible && (
        <TableFilter
          portal="mno"
          configs={filter.configs}
          candidateValues={candidateFilters}
          appliedValues={appliedFilters}
          onCandidateValuesChange={filter.handleEdit}
          onAppliedValuesChange={filter.handleApply}
          className="filters"
          data-testid="campaignsTableFilter"
        />
      )}
    </Flex>
  );
};

export default Filters;
